import { Injectable } from '@angular/core';
import { StepStatusEnum } from '../../enums/step-status';
import { StaticStepperOptions } from '../../models/stepper.model';

@Injectable({
  providedIn: 'root',
})
export class StaticStepperService {
  drawStaticStepper(staticStepper: StaticStepperOptions) {
    const stepperOption: {
      label: string;
      position: number;
      status: 'active' | 'done' | 'inactive';
    }[] = [];

    staticStepper.data.positions?.forEach((p, index) => {
      const state = this.setPositionStatus(index + 1, staticStepper);

      const baseLabel = p.position_name;

      stepperOption.push({
        label: `${index + 1}. ${baseLabel}`,
        position: p.position,
        status: state as 'active' | 'done' | 'inactive',
      });
    });

    return stepperOption;
  }

  setPositionStatus(
    index: number,
    staticStepper: StaticStepperOptions
  ): string {
    const current_position = staticStepper.data.current_position;
    if (staticStepper.data.state?.value === StepStatusEnum.COMPLETED) {
      return 'done';
    }
    if (current_position !== undefined) {
      if (current_position === index) {
        return 'active';
      } else if (current_position > index) {
        return 'done';
      } else if (current_position < index) {
        return 'inactive';
      }
    }
    return '';
  }
}
